import { SizedBox } from "../../../common/components/CommonBaseComponents";
import { C3Text } from "../../../common/components/text/CustomText";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import { Theme } from "../../../common/Theme";
import { useRef } from "react";
import QRCode from "react-qr-code";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import styled from "styled-components";
import { buildQrValue } from "../utils/qrValue";

// QR 이미지로 저장할 영역 (저장 버튼은 제외)
const CaptureArea = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    padding: 12px;
`;

function QRCodeCard({ device, storeId }) {
    const captureRef = useRef(null);

    const code = device?.modelNm || "";
    const deviceName = device?.alias || "";
    const deviceId = device?.deviceId;
    const qrValue = deviceId ? buildQrValue({ deviceId, storeId }) : null;

    const handleSaveImage = async () => {
        if (!captureRef.current) return;
        try {
            const canvas = await html2canvas(captureRef.current, {
                useCORS: true,
                scale: 2, // 고해상도
                backgroundColor: "#ffffff",
            });
            const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
            if (blob) saveAs(blob, `qr_${code || deviceId || "device"}.png`);
        } catch (error) {
            console.error("QR 이미지 저장 실패:", error);
        }
    };

    return (
        <SizedBox
            width={"188px"}
            height={"263px"}
            alignItem={"center"}
            justifyContent={"center"}
            borderRadius={"16px"}
            border={`1px solid ${Theme.color.gray200}`}
        >
            <CaptureArea ref={captureRef}>
                {qrValue ? (
                    <QRCode value={qrValue} size={120} level={"L"} />
                ) : (
                    <SizedBox width={"120px"} height={"120px"} backgroundColor={Theme.color.gray200} />
                )}
                <SizedBox height={"12px"} />
                <C3Text>{code}</C3Text>
                <SizedBox height={"4px"} />
                <C3Text fontWeight={"500"}>{deviceName}</C3Text>
            </CaptureArea>
            <SizedBox height={"19px"} />
            <SecondaryButton icon={"checked_black"} text={"Save an image"} onClick={handleSaveImage} disabled={!qrValue} />
        </SizedBox>
    );
}

export default QRCodeCard;
